var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplate1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "74px",
    viewBox: "0 0 108 74",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L-to-R",
    transform: "translate(-58.000000, -365.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(58.000000, 236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z",
    id: "Rectangle-47"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(8.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.2,
    stroke: "#979797",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-624",
    fill: "#666666",
    fillRule: "evenodd",
    points: "7.10037841 8.28357339 8.23167991 9.42369344 10.8010893 5.72727273 14.4755245 11.4545455 4.90909091 11.4545455"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#666666",
    fillRule: "evenodd",
    cx: 6.73426573,
    cy: 5.91608392,
    r: 1.00699301
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-122",
    fill: "#9E9E9E",
    x: 30,
    y: 28,
    width: 15,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-122",
    fill: "#E0E0E0",
    x: 30,
    y: 36,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-122",
    fill: "#E0E0E0",
    x: 30,
    y: 41,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(57.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.2,
    stroke: "#979797",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-624",
    fill: "#666666",
    fillRule: "evenodd",
    points: "7.10037841 8.28357339 8.23167991 9.42369344 10.8010893 5.72727273 14.4755245 11.4545455 4.90909091 11.4545455"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#666666",
    fillRule: "evenodd",
    cx: 6.73426573,
    cy: 5.91608392,
    r: 1.00699301
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-122",
    fill: "#9E9E9E",
    x: 80,
    y: 28,
    width: 15,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-122",
    fill: "#E0E0E0",
    x: 80,
    y: 36,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-122",
    fill: "#E0E0E0",
    x: 80,
    y: 41,
    width: 20,
    height: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate1);
export default __webpack_public_path__ + "static/media/template1.aa31646a1d0dca67923258d660d6209f.svg";
export { ForwardRef as ReactComponent };